const StratePraxedoInternational = {
    
    init() {
        const strates = document.querySelectorAll('.strate-praxedo-international.carousel');
        
        if (strates) {
            const sliderItem = $('.strate-praxedo-international.carousel .wrapper_regions .region');
            const leftBtn = $('.strate-praxedo-international.carousel .link_nav.left');
            const rightBtn = $('.strate-praxedo-international.carousel .link_nav.right');
    
            if (sliderItem.length > 1) {
                StratePraxedoInternational.build(strates);

                leftBtn.click(function() {
                    $('.owl-prev').trigger('click');
                    return false;
                });
                rightBtn.click(function() {
                    $('.owl-next').trigger('click');
                    return false;
                });
            } else {
                // leftBtn.addClass('no_slider');
                // rightBtn.addClass('no_slider');
            }
        }
    },

    build(strates) {
        // console.log('StratePraxedoInternational.build');

        strates.forEach((strate) => {
            strate.querySelector('.wrapper_regions').classList.add('owl-carousel');
        });

        const sliderWrapper = $('.strate-praxedo-international .wrapper_regions');

        sliderWrapper.owlCarousel({
            items: 1,
            nav: false,
            dots: true,
            stagePadding: 0,
            autoWidth: true,
            loop: true,
            margin: 20,
            slideBy: 1,
            768 : {
                items: 1,
                nav: false,
                dots: false,
                stagePadding: 0,
                autoWidth: true,
                loop: false,
                slideBy: 1,
            }
        });
    },
};

export default StratePraxedoInternational;
